import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import {
  StyleSheet,
  View,
  Text,
  Animated,
  TouchableOpacity,
  Dimensions,
  Image,
  Easing,
} from "react-native";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "../../../../Utils/responsive";
import { TriangleCorner } from "../../../../Components/ButtonOption/mandg";
import Intro from "./intro";
import "../../../../App.scss";
import Quant from "../../ATRQUANTS/index";
import { moduleid, custom2 } from "../../../../Utils/static-strings";
import HeaderMandG from "../../../../Components/MandG/Header/index";
const deviceWidth = Dimensions.get("screen").width;
export default function Index({
  moduleIndex,
  selectAnswerHandler,
  moduleObject,
  history,
  allmodule,
  resultContext,
  setfinishAnimate,
  skin,
}) {
  const actualWidth = deviceWidth;
  const animation = useRef(new Animated.Value(-deviceWidth)).current;
  const answerAnimations = useRef([]);
  const [show, setShow] = useState(() => {
    const skin = sessionStorage.getItem("skinName") || null;
    return skin === custom2;
  });
  const [display, setDisplay] = useState(false);
  const [atrQuant, setatrQuant] = useState(true);
  const [atrQuantModule, setAtrQuantModule] = useState(null);
  const answers = moduleObject.questions?.[moduleIndex]?.answers || [];
  useLayoutEffect(() => {
    const moduleArray = allmodule.filter(
      (module) => module.moduleid === moduleid.atrquant()
    );
    setAtrQuantModule(moduleArray[0]);
    setShow(skin === custom2);
  }, [allmodule, skin]);

  if (answerAnimations.current.length !== answers.length) {
    answerAnimations.current = answers.map(
      (_, index) =>
        answerAnimations.current[index] || new Animated.Value(-deviceWidth)
    );
  }

  useEffect(() => {
    animation.setValue(-deviceWidth);
    answerAnimations.current.forEach((anim) => anim.setValue(-deviceWidth));
    const answerTimings = answerAnimations.current.map((anim, index) =>
      Animated.timing(anim, {
        toValue: 0,
        duration: 600,
        delay: 500 + index * 100,
        useNativeDriver: false,
      })
    );
    Animated.parallel([
      Animated.timing(animation, {
        toValue: 0,
        duration: 600,
        useNativeDriver: false,
      }),
      ...answerTimings,
    ]).start();
  }, [answers.length, moduleIndex, show]);

  const setAnswer = (i) => {
    if (moduleIndex < 9) {
      selectAnswerHandler(
        moduleObject.moduleid,
        moduleObject.questions[moduleIndex].qid,
        moduleObject.questions[moduleIndex].answers[i].respid
      );
    } else {
      resultContext.setAnswer(
        moduleObject.moduleid,
        moduleObject.questions[moduleIndex].qid,
        moduleObject.questions[moduleIndex].answers[i].respid
      );
      resultContext.setModuleCompletedAtTime(moduleObject.moduleid);
      setfinishAnimate(moduleObject.moduleid);
      history.push("/");
      // if (atrQuantModule === undefined || atrQuantModule === null) {
      //     history.push('/');
      // } else {
      //     setatrQuant(false)
      // }
    }
  };
  const Showing = () => {
    setShow(false);
  };
  return (
    <>
      {atrQuant ? (
        <>
          <div
            style={{
              width: "100%",
              // flex: 1,
              height: "100%",
              minHeight: "100%",
              position: "absolute",
              //  display:'flex',
              //  justifyContent: 'center',
              //  alignItems: 'center',
              backgroundColor: "var(--game-background-color-atr)",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <HeaderMandG currentRoute={"Understanding"} />
            {show ? (
              <>
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    // transform: [{ translateX: animation }]
                  }}
                >
                  <Intro Showing={Showing} moduleObject={moduleObject} />
                </div>
              </>
            ) : (
              <>
                {/* <HeaderMandG currentRoute={"Understanding"} /> */}
                <View
                  style={[
                    {
                      height: "100%",
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                    },
                    actualWidth > 760 ? { marginBottom: hp("2%") } : null,
                  ]}
                >
                  <View>
                    <Animated.View
                      style={{ transform: [{ translateX: animation }] }}
                    >
                      <TriangleCorner
                        test={moduleObject.questions[moduleIndex].text}
                      />
                    </Animated.View>
                  </View>
                  <View>
                    {answers.map((answer, index) => (
                      <Animated.View
                        key={answer.respid || index}
                        style={{
                          transform: [
                            {
                              translateX: answerAnimations.current[index] || 0,
                            },
                          ],
                        }}
                      >
                        <TouchableOpacity
                          style={[
                            styles.button,
                            index > 0 ? styles.buttonSpacing : null,
                          ]}
                          onPress={() => setAnswer(index)}
                        >
                          <Text style={styles.buttonText}>{answer.text}</Text>
                        </TouchableOpacity>
                      </Animated.View>
                    ))}
                  </View>
                </View>
              </>
            )}
          </div>
        </>
      ) : (
        <Quant
          resultContext={resultContext}
          history={history}
          module={atrQuantModule}
        />
      )}
    </>
  );
}

const styles = StyleSheet.create({
  container1: {
    width: "100vw",
    height: "100vh",
    //flex: 1,
    // backgroundColor: "#eeeeee",
    overflow: "hidden",
  },
  container: {
    width: "100%",
    // flex: 1,
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "var(--game-background-color-atr)",
    overflow: "hidden",
  },
  topborder: {
    position: "relative",
    alignSelf: "center",
    borderTopColor: "var(--module-color-atr)",
    borderTopWidth: 3,
    marginBottom: hp("1.2%"),
  },
  Image: {
    position: "relative",
    alignSelf: "flex-end",
    marginLeft: "90vw",
    width: 48,
    resizeMode: "contain",
    marginRight: 8,
    height: 12,
  },
  button: {
    width: "13.5rem",
    alignSelf: "center",
    backgroundColor: "#ffffff",
    borderWidth: 3,
    borderStyle: "solid",
    borderColor: "var(--button-background-color-default)",
    borderRadius: 20,
  },
  buttonSpacing: {
    marginTop: 5,
  },
  buttonText: {
    alignSelf: "center",
    paddingHorizontal: 20,
    paddingTop: 9,
    paddingBottom: 8,
    color: "#000000",
    fontFamily: "Infra",
    fontSize: 19,
    lineHeight: 24,
    textAlign: "center",
    fontWeight: "var(--font-weight-semi-bold)",
    // textTransform: 'capitalize'
  },
});
